<form (ngSubmit)="validate()">
  <div class="select-practice-setting-infos-message" *ngIf="showUnautorizedMessage">
    Certains lieux d'exercice sont grisés et non sélectionnables<br>car leur sélection ne serait pas cohérente avec<br>le cadre d'exercicé connu dans les paramètres.
  </div>
  <frg-form-input
    label="Lieu d'exercice"
    type="ngSelect"
    [isClearableSelect]="false"
    [selectValue]="practiceLocations"
    [formGroup]="formGroup"
    [control]="formGroup.get('location')"
    id="location"
    isParentModal="true"
  ></frg-form-input>

  <div class="button-container center">
    <frg-button (click)="cancelSelection.emit()">
      <div title="Annuler">Annuler</div>
    </frg-button>
    <frg-button type="'submit'" [disabled]="!formGroup.valid">
      <div title="Valider">Valider</div>
    </frg-button>
  </div>
</form>
